import React, { ReactNode, useEffect, useState } from "react"
import "./CharacterizationWrapper.scss"
import TextComponent from "app_components/commons/TextComponent/TextComponent"
import ProgressBarComponent from "app_components/commons/progressBar"
import ButtonComponent from "app_components/commons/Button/ButtonComponent"
import { IAttemptSurvey } from "app_types/admin/survey/survet.types"
import { IQuestionEditor } from "app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions"

interface ICharacterizationWrapperProps {
  children: ReactNode[]
  onSubmit: () => void
  attempt: IAttemptSurvey
  questions: IQuestionEditor[]
  onChangeStep: (currentStep?: number) => void
  loading: boolean
}

function CharacterizationWrapper ({ children, onSubmit, attempt, questions, onChangeStep, loading }: ICharacterizationWrapperProps){
  const [currentStep, setCurrentStep] = useState<number>(0)
  const totalSteps = children?.length
  const showBackButton = currentStep > 0
  const showNextButton = currentStep < (totalSteps-1)
  const progress = `${(currentStep*100)/(totalSteps-1)}%`
  const currentQuestion = questions[currentStep]
  const isCurrentQuestionAnswered = attempt?.statistics?.findIndex((answer) => answer.question === currentQuestion.question._id) >= 0

  const renderCurrentStep = () => {
    return children?.length ? children[currentStep] : null
  }

  const handleClickNextButton = () => {
    if (showNextButton) {
      onChangeStep && onChangeStep(currentStep+1)
      setCurrentStep(currentStep+1)
    } else {
      onSubmit()
    }
  }

  const handleClickBackButton = () => {
    if (showBackButton) {
      onChangeStep && onChangeStep(currentStep-1)
      setCurrentStep(currentStep-1)
    }
  }

  return (
    <div className="characterization-wrapper--container">
      <TextComponent type="title" className="characterization-wrapper--title">Tu cuenta ha sido creada</TextComponent>
      <ProgressBarComponent progress={progress} />
      <p className="characterization-wrapper--description">"Nuestra misión es apoyarte. Ayúdanos a conocerte mejor."</p>
      {renderCurrentStep()}
      <div className="characterization-wrapper--container-button">
        <div>
          {showBackButton && (
            <ButtonComponent loading={loading} onClick={handleClickBackButton} variant="secondary" className="characterization-wrapper--back-button">Atrás</ButtonComponent>
          )}
        </div>
        <ButtonComponent loading={loading} disabled={!isCurrentQuestionAnswered} onClick={handleClickNextButton} variant="secondary" className="characterization-wrapper--back-button">
          {showNextButton ? 'Siguiente' : 'Finalizar encuesta'}
        </ButtonComponent>
      </div>
    </div>
  )
}

export default CharacterizationWrapper
